import { IProject } from "../../../../interfaces/project.interface";
import "./Sidebar.css";

import packageJson from "../../../../../package.json";
import { AddProjectDialog } from "../../../../components/AddProjectDialog";
import { useAppSelector } from "../../../../hooks";
import { useAppDispatch } from "../../../../hooks";
import { selected } from "../../../../slices/projectsSlice";
import { create } from "../../../../slices/dialogsSlice";

interface SidebarProjectButtonProps {
    project: IProject;
}

function SidebarProjectButton({ project }: SidebarProjectButtonProps) {
    const projectsDispatch = useAppDispatch();

    const selectProject = () => {
        projectsDispatch(selected(project));
    };

    return (
        <div className="project-button" onClick={selectProject}>
            {project.title}
        </div>
    );
}

interface SidebarProps {
    updateProjects: () => void;
}

function Sidebar({ updateProjects }: SidebarProps) {
    const dispatch = useAppDispatch();

    const projects = useAppSelector((state) => state.projects.projects);

    const openAddProject = () => {
        dispatch(
            create({
                id: 0,
                component: AddProjectDialog,
                props: {
                    updateProjects: updateProjects,
                },
            }),
        );
    };

    return (
        <>
            <div className="sidebar">
                {projects?.map((p, i) => <SidebarProjectButton key={i} project={p} />) ?? (
                    <div>Loading...</div>
                )}
                <button onClick={openAddProject}>New Project</button>
                <div className="version-number">{packageJson.version}</div>
            </div>
        </>
    );
}

export default Sidebar;
